module.exports = __webpack_public_path__ + "static/left-img1-5b61cf64d6d1f58e0bed17a55f46ebb9.png";